import styled from "styled-components";

export const ConsentRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #374151;
  cursor: pointer;
  text-align: left;

  input[type="checkbox"] {
    width: 1rem;
    height: 1rem;
    margin: 0.125rem 0 0;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: #3B82F6;
  }

  a {
    color: #3B82F6;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      color: #2563EB;
      text-decoration: underline;
    }
  }
`;
